/* ============================================================
   CABECERA FIJA SOBRE EL BANNER, CON FONDO AL BAJAR, Y LOGO QUE CAMBIA

   ⚠️⚠️ TRAMPAS QUE COSTARON VARIOS INTENTOS, POR SI HAY QUE VOLVER AQUI

   1) EL TEMA NO DESPLAZA LA VENTANA
        html / body   overflow-y: hidden
        .page-wrapper overflow-y: auto   <- AQUI ocurre el scroll
      window.addEventListener('scroll') no se dispara nunca.

   2) LA SECCION DEL HERO RECORTA
      .seccion-hero-nazalea tiene overflow:hidden, asi que subir el hero con
      margin-top negativo movia la caja pero no los pixeles.

   3) EL LOGO NO SE PUDO HACER CON CSS
      Tres intentos con pseudoelementos y todos perdian. Ahora se inserta un
      <img> real y se cambia su src. Deterministico.

   4) LA CABECERA IBA EN ABSOLUTE Y SE DESPLAZABA CON LA FOTO
      Ahora va FIXED. Como la barra de promocion si se desplaza, la cabecera
      se apoya debajo de ella mientras se ve, y se ancla a 0 cuando pasa.
      Ese desplazamiento se publica en --pn-header-top.

   El logo original del tema es TEXTO (<span>Nusa Azalea</span>), no imagen.
   No se borra: se esconde por CSS para accesibilidad y SEO.
   ============================================================ */
(function () {
  'use strict';

  var LOGO_OSCURO = 'https://cdn.shopify.com/s/files/1/0818/6406/5278/files/nusa-logo-oscuro.png?v=1786588598&width=500';
  var LOGO_BLANCO = 'https://cdn.shopify.com/s/files/1/0818/6406/5278/files/nusa-logo-blanco.png?v=1786588598&width=500';

  var raiz = document.documentElement;

  function elem(sel) { return document.querySelector(sel); }

  function medir() {
    var head = elem('#shopify-section-header-nazalea') || elem('[id*="header-nazalea"]');
    var h = head ? Math.round(head.getBoundingClientRect().height) : 0;
    if (h) { raiz.style.setProperty('--pn-header-h', h + 'px'); }
    return h;
  }

  function contenedorQueScrollea() {
    var w = elem('.page-wrapper');
    if (w) {
      var ov = getComputedStyle(w).overflowY;
      if ((ov === 'auto' || ov === 'scroll') && w.scrollHeight > w.clientHeight + 10) { return w; }
    }
    return null;
  }

  function menuAbierto() { return !!elem('.header-nazalea__mega--abierto'); }

  function ponerImagen() {
    var enlace = elem('.header-nazalea__logo-enlace');
    if (!enlace) { return null; }
    var img = enlace.querySelector('img.pn-logo');
    if (img) { return img; }
    img = document.createElement('img');
    img.className = 'pn-logo';
    img.alt = '';
    img.setAttribute('aria-hidden', 'true');
    img.src = LOGO_OSCURO;
    var pre = new Image();
    pre.src = LOGO_BLANCO;                 // precarga: el cambio no parpadea
    enlace.insertBefore(img, enlace.firstChild);
    return img;
  }

  function arrancar() {
    var img = ponerImagen();
    var hero = elem('.hero-nazalea');
    if (!hero) { return; }                 // sin banner: se queda el oscuro
    if (raiz.dataset.pnHeader === '1') { return; }
    raiz.dataset.pnHeader = '1';

    raiz.classList.add('pn-con-hero');
    var alto = medir();
    var promo = elem('.seccion-barra-promo-nazalea') || elem('[class*="barra-promo"]');

    function revisar() {
      // La cabecera se apoya bajo la promo mientras se vea; luego a 0
      var top = 0;
      if (promo) {
        var b = promo.getBoundingClientRect().bottom;
        top = b > 0 ? Math.round(b) : 0;
      }
      raiz.style.setProperty('--pn-header-top', top + 'px');

      var sobreElBanner = (hero.getBoundingClientRect().bottom - alto - top) > 0;
      var blanco = sobreElBanner && !menuAbierto();
      raiz.classList.toggle('pn-header-solido', !sobreElBanner);
      raiz.classList.toggle('pn-logo-blanco', blanco);
      if (img) {
        var quiere = blanco ? LOGO_BLANCO : LOGO_OSCURO;
        if (img.getAttribute('src') !== quiere) { img.setAttribute('src', quiere); }
      }
    }

    revisar();

    var cont = contenedorQueScrollea();
    if (cont) { cont.addEventListener('scroll', revisar, { passive: true }); }
    window.addEventListener('scroll', revisar, { passive: true });

    var head = elem('.header-nazalea');
    if (head && typeof MutationObserver === 'function') {
      new MutationObserver(revisar).observe(head, {
        attributes: true, attributeFilter: ['class'], subtree: true
      });
    }

    var t;
    window.addEventListener('resize', function () {
      clearTimeout(t);
      t = setTimeout(function () { alto = medir(); revisar(); }, 150);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancar);
  } else {
    arrancar();
  }
  window.addEventListener('load', function () { medir(); arrancar(); });
  document.addEventListener('shopify:section:load', function () {
    raiz.dataset.pnHeader = '';
    arrancar();
  });
})();